import { render, staticRenderFns } from "./visitor-layout.vue?vue&type=template&id=55cb976b"
import script from "./visitor-layout.ts?vue&type=script&lang=js&external"
export * from "./visitor-layout.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports